import React from "react";
import "./Section3.css";

const Section3 = () => {
  return (
   <section className="section3-hdt">
  <div className="section3-wrapper-hdt">
    <div className="section3-box-hdt">
      <div className="section3-tag-hdt">
        <span>Produits populaires</span>
        <span className="section3-tag-line-hdt"></span>
      </div>

      <h2 className="section3-title-hdt">
        Découvrez <span>Vos Produits</span>
        <br />
        Américains Préférés Ici !
      </h2>

      <p className="section3-text-hdt">
        Nous vous proposons chaque semaine une sélection de produits
        américains populaires pour vous faire découvrir de nouvelles
        saveurs et retrouver vos marques préférées.
      </p>
    </div>

    <div className="section3-search-hdt">
      <div className="section3-item-hdt">
        <div className="section3-icon-hdt">📍</div>
        <div className="section3-item-content-hdt">
          <h4>Lieu</h4>
          <p>Cassablanca, Baguida , Dekon</p>
        </div>
      </div>

      <div className="section3-divider-hdt"></div>

      <div className="section3-item-hdt">
        <div className="section3-icon-hdt">🛒</div>
        <div className="section3-item-content-hdt">
          <h4>Produits</h4>
          <p>+10000 Choix disponibles</p>
        </div>
      </div>

      <div className="section3-divider-hdt"></div>

      <div className="section3-item-hdt">
        <div className="section3-icon-hdt">📅</div>
        <div className="section3-item-content-hdt">
          <h4>Date</h4>
          <p>8h - 21h00 et 7j / 7</p>
        </div>
      </div>

      <div className="section3-divider-hdt"></div>

      <div className="section3-item-hdt">
        <div className="section3-icon-hdt">🚚</div>
        <div className="section3-item-content-hdt">
          <h4>Livraison</h4>
          <p>Rapide et pratique</p>
        </div>
      </div>

      {/* <button className="section3-btn-hdt">Commander</button> */}
    </div>
  </div>
</section>
  );
};

export default Section3;